/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes";
import { AuthProvider, AuthConsumer } from "./components/context/AuthContext";
import LoadingIndicator from "./components/widgets/LoadingIndicator/LoadingIndicator";
import Sidebar from "./components/widgets/SideNavBar/Sidebar";

const basename = "/contentadmin";

class App extends Component {
    state = {
        isSidebarExpanded: false
    }

    toggleSidebar = () => {
        this.setState(prevState => ({
            isSidebarExpanded: !prevState.isSidebarExpanded
        }));
    }

    render() {
        return (
            <AuthProvider>
                <Router basename={basename}>
                    <AuthConsumer>
                        {({isLoggedIn}) =>
                            <div className="pe-container root-container">
                                {isLoggedIn ? (
                                    <div className={`page ${(this.state.isSidebarExpanded ? "sidebar-expanded" : "")}`}>
                                        <Sidebar isExpanded={this.state.isSidebarExpanded} toggleExpanded={this.toggleSidebar} />
                                        <Routes/>
                                    </div>
                                ) : <LoadingIndicator/>}
                            </div>
                        }
                    </AuthConsumer>
                </Router>
            </AuthProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js